import React, { useEffect, useRef } from 'react';
import Sym from './Sym';

/**
 * Menú desplegable anclado a un disparador (menú de usuario, presets de periodo…).
 * Cierra con Escape, con clic fuera y al elegir una opción.
 *
 * @param {boolean} open
 * @param {Function} onClose
 * @param {'left'|'right'} align  borde por el que se alinea (default right)
 * @param {number} width
 */
export const Menu = ({ open, onClose, align = 'right', width = 250, style, children }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    const onDown = (e) => {
      // El disparador vive fuera del menú: si el clic no cae dentro del panel,
      // se cierra. El propio disparador hace toggle, así que no hay parpadeo.
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onDown);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className="as2-menu"
      role="menu"
      style={{
        top: 'calc(100% + 8px)',
        [align]: 0,
        width,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

/** Opción de menú. `tone="danger"` para acciones destructivas (cerrar sesión). */
export const MenuItem = ({ icon, tone, onClick, children, ...rest }) => (
  <button
    type="button"
    role="menuitem"
    className={['as2-menu-item', tone === 'danger' ? 'as2-menu-item--danger' : ''].filter(Boolean).join(' ')}
    onClick={onClick}
    {...rest}
  >
    {icon ? <Sym name={icon} size={20} style={{ color: tone === 'danger' ? 'inherit' : 'var(--muted)' }} /> : null}
    {children}
  </button>
);

export const MenuLabel = ({ children }) => <div className="as2-menu-label">{children}</div>;
export const MenuSeparator = () => <div className="as2-menu-sep" />;

export default Menu;
